export enum QuotaType {
    RECHARGE = 1,            // recarga
    DISCHARGE = 2,           // descarga
}